<template>
    <v-container>
        <div id="inicio" style="margin-top: -5%;">
            <div class="jumping-box" style="padding-left: 1%; padding-right: 1%; width: 10%; height: 30%; position: fixed; right: 15px;">
                <h3 style="color: black;">¿Es conocedor de un <span style="color: #ffcd07;">hecho de corrupción?</span></h3>
                <a href="https://portal.paco.gov.co/index.php?pagina=denuncie" target="_blank">
                    <v-img :src="require('../assets/denuncie.png')" style="width: auto; height:120px" contain></v-img>
                </a>
            </div>
            <div style="text-align: justify;">
                <v-row>
                    <v-col cols="12" lg="12">
                        <h2>¿Qué es el control social?</h2>
                        <p>                            
                            En Colombia, el <b>control social</b> se define, en la mayoría de su normativa, como el derecho y deber que tiene la ciudadanía de 
                            participar de manera individual o a través de sus organizaciones, redes sociales e instituciones, en la vigilancia de la gestión 
                            pública y sus resultados (Ley 1757 de 2015, artículo 60), lo cual permite a la ciudadanía influir, orientar, corregir, rectificar  
                            acciones, vigilar la ejecución de los recursos e implementar programas públicos, con el objetivo de contribuir a una adecuada 
                            ejecución e intervención pública con máxima  eficiencia y transparencia (Instituto Distrital de Patrimonio Cultural, 2019, p. 6).<br><br>
                            
                            El <b>control social</b> y la participación ciudadana se destacan entonces como estrategias preventivas para la lucha contra la corrupción.<br><br>
                            
                            El <b>control social</b> es de vital importancia porque es la ciudadanía quien de manera voluntaria y activa se organiza para hacer seguimiento y 
                            monitoreo a aspectos fundamentales de la gestión pública, programas, proyectos entre otros.
                        </p>
                        <h2>¿Por qué es importante el control social en la lucha contra la corrupción?</h2>
                        <p>                            
                            Mediante el ejercicio del control social se pueden prevenir y evitar actos de corrupción ya que puede aportar en la detección de casos 
                            asociados a abuso de poder, desvío de recursos, identificación de riesgos o hechos de corrupción en la gestión pública, obras inconclusas 
                            (elefantes blancos) que revelan el mal manejo de los recursos públicos y por supuesto permite también denunciar dichas irregularidades 
                            ante las autoridades correspondientes.
                        </p>
                        <h2>¿Por qué es fundamental realizar control social alrededor de problemáticas ambientales como la deforestación desde un enfoque de lucha contra la corrupción?</h2>
                        <p>                            
                            El control social enfocado al seguimiento de asuntos ambientales suscita una especial relevancia ya que brinda la posibilidad de que las organizaciones 
                            sociales, liderazgos ambientales, veedores ciudadanos, investigadores, periodistas, activistas y demás ciudadanos se involucren de manera activa en 
                            los asuntos asociados a la gestión ambiental y en las decisiones en materia de política pública que involucran la protección y defensa de los recursos 
                            naturales y ecosistemas estratégicos del país.  Para el caso puntual de delitos ambientales como la deforestación, el ejercicio del control 
                            social contribuye en la lucha contra la corrupción asociada a esta problemática ya que permite entre otros:
                            <ul>
                                <li>
                                    Denunciar irregularidades o cualquier práctica ilegal relacionada con la pérdida de bosques ante las autoridades competentes.
                                </li>
                                <li>
                                    El control social ejercido a través de mecanismos como derechos de petición, solicitudes de acceso a información pública, consultas 
                                    populares, audiencias públicas o consultas previas permite que la ciudadanía, líderes y lideresas ambientales, veedurías ciudadanas y 
                                    organizaciones de la sociedad civil puedan participar directamente en la toma de decisiones sobre la gestión ambiental.
                                </li>
                                <li>
                                    Involucrar a la ciudadanía en la vigilancia y seguimiento de los asuntos o ambientales fortalece la democracia participativa, y 
                                    posiciona a las comunidades de los territorios como vigilantes y protectores de los recursos naturales y de sus derechos humanos fundamentales.
                                </li>
                                <li>
                                    Genera colaboración y complementa la labor de las entidades de prevención, investigación y sanción al reportar, denunciar o proporcionar 
                                    información que dé evidencia sobre actividades ilegales asociadas a corrupción. Esto sin duda facilita la coordinación entre la sociedad 
                                    civil y las instituciones gubernamentales para abordar la lucha contra la corrupción alrededor de los delitos ambientales. 
                                </li>
                            </ul>
                        </p>
                        <h2>¿Qué acciones se encuentra desarrollando la Secretaría de Transparencia en la materia?</h2>
                        <p>                            
                            La Secretaría de Transparencia a través de la formulación de la Estrategia Nacional de Lucha contra la corrupción priorizó como un eje de 
                            fortalecimiento la promoción del control social y la participación ciudadana a los recursos públicos abriendo la posibilidad de presentar 
                            informes y recomendaciones a la Secretaría de Transparencia de la Presidencia de la República, en los que indiquen si las Comisiones 
                            Regionales de Moralización ubicadas en su departamento les están brindando espacios de discusión y control de posibles hechos de corrupción 
                            conocidos y también articulando las diferentes organizaciones y veedurías que permita consolidar una red nacional de víctimas de actos de 
                            corrupción. El vínculo de la corrupción en la comisión de delitos ambientales en territorios como el Arco Amazónico es evidente, por lo cual 
                            esta promoción del control social también está enfocado al seguimiento problemáticas ambientales de alto impacto como la deforestación. <br><br>
                            
                            En virtud de este compromiso, la Secretaría de Transparencia ha recibido desde 2021 asistencia técnica en el marco del programa 
                            Territorios Forestales Sostenibles-TEFOS por parte de la Oficina de las Naciones Unidas Contra la Droga y el Delito para la Región 
                            Andina y el Cono Sur, desarrollando distintas acciones y herramientas para abordar los principales riesgos y hechos de corrupción en 
                            torno a la deforestación, así como insumos para el análisis, la detección temprana y la mitigación de esta problemática en departamentos 
                            como Meta, Caquetá, Guaviare y Amazonas. Conoce más información del programa visitando el siguiente enlace: 
                            <a href="https://programatefos.com/fortalecimiento-estado-derecho-ambiental/" target="_blank">
                                Fortalecimiento del estado de derecho ambiental</a>
                        </p>
                        <h2>Acceso a documentos</h2>
                        <p>                            
                            A continuación, encontrarás información y documentos de utilidad en materia de Control Social Ambiental para la lucha contra la corrupción: 
                            <ul>
                                <li>Fortalecimiento del control social: 
                                    <a href="https://saga.unodc.org.co/es/fortalecimiento-del-control-social" target="_blank">
                                        https://saga.unodc.org.co/es/fortalecimiento-del-control-social</a>
                                </li>
                                <li>
                                    Documento instrumento para la inclusión del enfoque anticorrupción en las estrategias y medidas de lucha contra la deforestación: 
                                    <a href="https://saga.unodc.org.co/es/fortalecimiento-del-control-social" target="_blank">
                                        enlace</a>
                                </li>
                                <li>Curso control social y veedurías ambientales del Ministerio de Medio Ambiente:
                                    <a href="https://www.minambiente.gov.co/inscripciones-abiertas-para-participar-en-curso-control-ciudadano-y-veedurias-ambientales-2024/" target="_blank">
                                        ver más</a>
                                </li>
                                <li>Curso Corrupción y Deforestación: Una aproximación general al fenómeno:
                                    <a href="https://elearning.unodc.org.co/login/index.php?" target="_blank">
                                        clic aquí</a>
                                </li>
                            </ul>
                        </p>
                        <p>
                            Conoce las organizaciones y veedurías ciudadanas que realizan control social a problemáticas ambientales en territorios estratégicos 
                            del Arco Amazónico, visita el visor aquí:
                            
                            <div id="map" style="height: 600px;"></div>
                        </p>
                        <h2>Mensaje</h2>
                        <p>                            
                            Recuerda que si eres conocedor(a) de algún hecho de corrupción asociados problemáticas ambientales, puedes interponer tu denuncia 
                            mediante el botón de "<a href="https://portal.paco.gov.co/index.php?pagina=denuncie" target="_blank">Denuncia</a>"
                            en el Portal Anticorrupción de Colombia - PACO. Este espacio está diseñado para que cualquier ciudadano 
                            (a) pueda reportar de manera segura y confidencial cualquier acto sospechoso de corrupción que afecte el medio ambiente.<br><br>

                            Cuando se ingrese a la página principal del Portal Anticorrupción de Colombia-PACO, la sección de Control Social Ambiental, debe dirigir a 
                            una página principal donde esté toda la información de la sección y los recursos diseñados. 
                        </p>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-container>  
</template>
<script>
import axios from 'axios';
import L from 'leaflet';
import SectionTitle from '@/components/SectionTitle.vue';

export default {
    components: {
        SectionTitle
    },
    data() {
        return {
            deptos2: [
                { oid_depto: 1, n_depto: 'Valle del Cauca', lat: 3.43722, lng: -76.5225, deforestacion: 20, n_municipio: 'Cali', deforestacion_municipio: 20 },
                { oid_depto: 2, n_depto: 'Antioquia', lat: 6.25184, lng: -75.56359, deforestacion: 30, n_municipio: 'Medellin', deforestacion_municipio: 30 },
                { oid_depto: 3, n_depto: 'Chocó', lat: 5.96666, lng: -76.6500, deforestacion: 45, n_municipio: 'Quipdo', deforestacion_municipio: 45 },
                { oid_depto: 4, n_depto: 'Bogotá', lat: 4.60971, lng: -74.08175, deforestacion: 45, n_municipio: 'Chia', deforestacion_municipio: 20 },
                { oid_depto: 4, n_depto: 'Bogotá', lat: 4.60971, lng: -74.08175, deforestacion: 45, n_municipio: 'Sopo', deforestacion_municipio: 25 },
            ],
            visor: [
                { oid_depto: 1, n_depto: 'CAQUETÁ', lat: 1.61438, lng: -75.60623, oid_municipio:1, n_municipio: 'Florencia', n_organizacion: 'Ejemplo1', tematica: 'IT', correo: 'ejemplo1@gmail.com' },
                { oid_depto: 1, n_depto: 'CAQUETÁ', lat: 1.61438, lng: -75.60623, oid_municipio:2, n_municipio: 'San Vicente Del Caguán', n_organizacion: 'Ejemplo2', tematica: 'IT', correo: 'ejemplo2@gmail.com' },
                { oid_depto: 2, n_depto: 'PUTUMAYO', lat: 1.15284, lng: -76.65208, oid_municipio:3, n_municipio: 'Puerto asís', n_organizacion: 'Ejemplo3', tematica: 'IT', correo: 'ejemplo3@gmail.com' },
                { oid_depto: 2, n_depto: 'PUTUMAYO', lat: 1.15284, lng: -76.65208, oid_municipio:4, n_municipio: 'Mocoa', n_organizacion: 'Ejemplo4', tematica: 'IT', correo: 'ejemplo4@gmail.com' },
                { oid_depto: 3, n_depto: 'AMAZONAS', lat: -4.21528, lng: -69.94056, oid_municipio:5, n_municipio: 'Leticia', n_organizacion: 'Ejemplo5', tematica: 'IT', correo: 'ejemplo5@gmail.com' },
            ]
        };  
    },
    mounted() {
        this.initializeMap();
        this.addDeptosToMap();
    },
    methods: {
        initializeMap() {
            this.map = L.map('map').setView([3.43722, -76.5225], 5); // Coordenadas de Colombia

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 18,
                attribution: '© OpenStreetMap'
            }).addTo(this.map);
        },
        /* FUNCIONAL para ver municipios y deptos*/
        addDeptosToMap() {
            // Agrupar municipios por departamento
            const deptosGrouped = this.visor.reduce((acc, depto) => {
                if (!acc[depto.oid_depto]) {
                    acc[depto.oid_depto] = {
                        n_depto: depto.n_depto,
                        lat: depto.lat,
                        lng: depto.lng,
                        municipios: []
                    };
                }
                acc[depto.oid_depto].municipios.push({
                    n_municipio: depto.n_municipio,
                    n_organizacion: depto.n_organizacion,
                    tematica: depto.tematica,
                    correo: depto.correo
                });
                return acc;
            }, {});

            // Agregar círculos y popups para cada departamento
            Object.values(deptosGrouped).forEach(depto => {
                if (depto.lat && depto.lng) { // Verifica que las coordenadas existan
                    const color = 'blue';
                    const circle = L.circle([depto.lat, depto.lng], {
                        color: color,
                        fillColor: color,
                        fillOpacity: 0.5,
                        radius: 25000
                    }).addTo(this.map);

                    let popupContent = `<b>${depto.n_depto}</b><br>`;
                    depto.municipios.forEach(municipio => {
                        popupContent += `Municipio: <b>${municipio.n_municipio}</b> - Organización: <b>${municipio.n_organizacion}</b>
                        - Temática: <b>${municipio.tematica}</b>
                        - Correo: <b>${municipio.correo}</b><br>`;
                    });

                    circle.bindPopup(popupContent);
                } else {
                    console.warn(`Coordenadas inválidas para el departamento: ${depto.n_depto}`);
                }
            });
        },
        getColor(deforestacion) {
            // Define colores según el rango de deforestación
            return deforestacion > 40 ? 'red' :
            deforestacion > 30 ? 'orange' :
                    deforestacion > 20 ? 'yellow' :
                    'green';
        },
        /*
        async addDeptosToMap() {
            const responseCasoxDepto = await axios.get('casoxdeptos');
            
            if (Array.isArray(responseCasoxDepto.data.casoxdepto)) {
                this.casoxdepto = responseCasoxDepto.data.casoxdepto;
                    this.casoxdepto = this.casoxdepto.map(cxd => {
                        return {
                            oid_depto: cxd.oid_depto,
                            n_depto: cxd.n_depto,
                            lat: cxd.lat,
                            lng: cxd.lng,
                            num_caso: cxd.num_caso,
                        };
                    });
            } else {
                console.error('Los datos de casoxdepto no son un arreglo:', responseCasoxDepto.data);
            }

            //console.log('deptos', this.deptos2);
            //console.log('casoxdepto',this.casoxdepto);
            this.casoxdepto.forEach(depto => {
                if (depto.lat && depto.lng) { // Verifica que las coordenadas existan
                    const color = this.getColor(depto.num_caso);
                    const circle = L.circle([depto.lat, depto.lng], {
                        color: color,
                        fillColor: color,
                        fillOpacity: 0.5,
                        radius: 25000
                    }).addTo(this.map);

                    circle.bindPopup(`
                        <b>${depto.n_depto}</b><br>
                        # de Casos: ${depto.num_caso}
                    `);
                } else {
                    console.warn(`Coordenadas inválidas para el departamento: ${depto.n_depto}`);
                }
            });
        },
        getColor(num_caso) {
            // Define colores según el rango de deforestación
            return num_caso > 40 ? 'red' :
            num_caso > 30 ? 'orange' :
            num_caso > 20 ? 'yellow' :
                    'green';
        },*/
        
    }
}
</script>
<style>
    #map {
        height: 600px;
        width: 300px;
        position: relative;
        z-index: 1;
    }
    .custom-h1 {
        font-size: 2.5em; /* Puedes ajustar el tamaño según tus necesidades */
        font-weight: bold; /* Otras propiedades de estilo si es necesario */
    }

    .custom-h3 {
        font-size: 1.5em; /* Puedes ajustar el tamaño según tus necesidades */  
    }
    p {
        /* font-family: 'Heebo', sans-serif !important; */
        font-family: 'Roboto' !important;
        font-size: 14px;     
        line-height: 1.6em;
    }
    h1 {
        /* font-family: 'Heebo', sans-serif; */
        font-family: 'Roboto' !important;
        text-align: center;
    }
    h2 {
        /* font-family: 'Heebo', sans-serif; */
        font-family: 'Roboto' !important;
        font-size: 18px;  
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    .p1{
        font-size: 17px; 
        color: rgb(15, 135, 201); 
        line-height: 1em;
    }
    /* SALTO DEL MENU */
    .jumping-box {
        animation: jump 1s infinite;
    }
    @keyframes jump {
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-10px);
        }
    }
</style>